// Accurate plan label for the account portal.
// Shows Trial / Starter / Pro / Premium exactly per the company's real plan,
// and a live countdown ("Trial · N days left") while trialing.
export function planDisplay(company) {
  if (!company) return "Trial";
  const isTrial =
    company.effective_plan === "trial" ||
    company.plan === "trial" ||
    company.subscription_status === "trial";
  if (isTrial) {
    const ends = company.trial_ends_at ? new Date(company.trial_ends_at) : null;
    if (ends && !isNaN(ends.getTime())) {
      const ms = ends.getTime() - Date.now();
      if (ms <= 0) return "Trial expired";
      const days = Math.ceil(ms / 86400000);
      if (days <= 1) return "Trial · last day";
      return `Trial · ${days} days left`;
    }
    return "Free Trial";
  }
  return company.plan_label || "Trial";
}
